const TipSummary = () => import(/* webpackChunkName: "tipSummary" */ '@/components/dashboard/tipSummary')
export default {
    name: 'tipSummary',
    path: 'tip-summary',
    redirect: '/tip-summary/index',
    meta: {label: 'tipSummary'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'tipSummary', auth: [0, 1, 2, 3, 4, 5, 6, 7, 10]},
            component: TipSummary,
            props: true
        }
    ]
}
